import { getCountryName } from '@monoimin/utils/formatters';

import { metaTitlesForCountryDict, replaceTemplate } from '@monoimin/intl';

import { formatCountryName } from '../formatCountryName';

import type { EnOrRuLocale } from '@monoimin/sb-types';
import type { PageMetaTitles } from '../../types';

export const defineMetaTitlesForCountry = (
  countryCode: string,
  locale: EnOrRuLocale,
  project: string
): PageMetaTitles => {
  const countryName = getCountryName(countryCode, locale);

  const formattedCountryName = formatCountryName(countryName, locale);

  const metaTitles = metaTitlesForCountryDict[locale];

  const replacers = {
    countryName: formattedCountryName || '',
    project: project,
  };

  return {
    title: replaceTemplate(metaTitles.title, replacers),
    description: replaceTemplate(metaTitles.description, replacers),
  };
};

export default defineMetaTitlesForCountry;
